import classNames from 'classnames';
import { Button, ContentBlock, Txt } from 'components/index';
import FlexContainer from '../FlexContainer';
import styles from './ErrorMessage.module.scss';

/**
 * ErrorMessage
 *
 * @return {JSX.Element}
 */
const ErrorMessage = ({
  className,
  title = 'An error occurred',
  description,
  action,
  actionTitle,
  actions,
  small,
  ...rest
}) => {
  return (
    <ContentBlock
      className={classNames(
        styles.ErrorMessage,
        small && styles.ErrorMessage__small,
        className,
        `${ErrorMessage.displayName}`
      )}
      column
      alignCenter
      gap
      {...rest}
    >
      {title ? <Txt xxx>{title}</Txt> : null}
      {description ? (
        <Txt error xx regular>
          {description}
        </Txt>
      ) : null}
      {actions ? (
        <FlexContainer gap>
          {actions.map(({ onClick, actionTitle, ...rest }) => (
            <Button key={actionTitle} onClick={onClick} {...rest}>
              <Txt>{actionTitle}</Txt>
            </Button>
          ))}
        </FlexContainer>
      ) : action ? (
        <Button onClick={action}>
          <Txt>{actionTitle}</Txt>
        </Button>
      ) : null}
    </ContentBlock>
  );
};

ErrorMessage.displayName = 'ErrorMessage';

export default ErrorMessage;
